import { isValidUrl } from "./url";

export const EMPTY_DOCUMENT = {
  link: "",
  title: "",
  type: "internal",
  category: "",
  confidentialityLevel: "",
};

export const getDocumentErrors = (documents, translate) =>
  (documents || [])
    .map((document, index) => {
      const hasUserValue =
        document.title ||
        document.link ||
        document.category ||
        document.confidentialityLevel;
      if (!hasUserValue) return null;
      if (!document.link) {
        return translate("Document {{number}} must have a link.", {
          number: index + 1,
        });
      }
      if (!isValidUrl(document.link)) {
        return translate("Document {{number}} must have a valid URL.", {
          number: index + 1,
        });
      }
      return null;
    })
    .filter(Boolean);

export const mapPrefillResources = (resources) =>
  (Array.isArray(resources) ? resources : []).map((resource) => ({
    ...EMPTY_DOCUMENT,
    link: resource.link || resource.path || "",
    title: resource.title || "",
    type: resource.documentType || resource.type || "external",
    category: resource.category || "",
    confidentialityLevel: resource.confidentialityLevel || "",
  }));
